module.exports = __webpack_public_path__ + "static/media/memories_2.469c2796.jpg";